export interface Upsell {
  id: string
  name: string
  color: string
  description: string
  hook: string
  oldPrice: number
  price: number
  icon: string
  image?: string
  badge?: string
  bonuses: string[]
  keyBenefits: string[]
}

export const UPSELLS: Upsell[] = [
  {
    id: 'alergias',
    name: 'Kit Alergias Alimentarias',
    color: '#6B5B8B',
    description: 'Comé seguro y rico aunque tengas restricciones.',
    hook: 'Recetas 100% libres de los alérgenos más comunes.',
    oldPrice: 29980,
    price: 11990,
    icon: 'ShieldCheck',
    image:
      'https://cdn.magicpatterns.com/uploads/rD7VsN5MrHnjTT5N99n2JK/Mockup_kit_alergias_alimentarias.png',
    badge: 'MÁS ELEGIDO',
    bonuses: [
      '40 recetas de almuerzos y cenas para alergias',
      '40 recetas de desayunos y meriendas para alergias',
      '40 recetas saludables para alergias',
    ],
    keyBenefits: [
      'Sin lácteos · sin gluten · sin huevo · sin frutos secos',
      'Ideal para toda la familia con restricciones',
      'Ingredientes accesibles en cualquier supermercado',
    ],
  },
  {
    id: 'lactosa',
    name: 'Kit Sin Lactosa',
    color: '#8B7A2E',
    description: 'Todo el sabor, sin el malestar.',
    hook: 'Comé tus comidas favoritas sin hinchazón ni dolor.',
    oldPrice: 29980,
    price: 11990,
    icon: 'MilkOff',
    image:
      'https://cdn.magicpatterns.com/uploads/iHRYaXQrXDiCFqLjqpbh3e/Mockup_kit_sin_lactosa.png',
    bonuses: [
      '30 recetas de almuerzos y cenas sin lactosa',
      '30 recetas de desayunos y meriendas sin lactosa',
      '30 recetas saludables sin lactosa',
    ],
    keyBenefits: [
      'Apto intolerantes a la lactosa',
      'Alternativas vegetales deliciosas a la leche y quesos',
      'Sin renunciar a postres y meriendas ricas',
    ],
  },
  {
    id: 'colon',
    name: 'Kit Colon Irritable',
    color: '#4A7C59',
    description: 'Volvé a disfrutar de comer sin miedo.',
    hook: 'Recetas pensadas para no irritar tu intestino.',
    oldPrice: 29980,
    price: 11990,
    icon: 'Wind',
    image:
      'https://cdn.magicpatterns.com/uploads/jTnrxwBzMuV7zNuqZ8isv7/Mockup_kit_colon_irritable.png',
    bonuses: [
      '40 recetas para almuerzos y cenas para colon irritable',
      '40 recetas para desayunos y meriendas para colon irritable',
      '40 recetas para eventos para colon irritable',
    ],
    keyBenefits: [
      'Ingredientes seguros, bajos en FODMAPs',
      'Reduce hinchazón, dolor y malestar',
      'Comidas para todos los días + reuniones',
    ],
  },
  {
    id: 'antiinflamatorio',
    name: 'Kit Antiinflamatorio',
    color: '#7A3B1E',
    description: 'Reducí la inflamación crónica con cada comida.',
    hook: 'Bajá la inflamación que afecta tu energía y tu peso.',
    oldPrice: 29980,
    price: 11990,
    icon: 'Leaf',
    image:
      'https://cdn.magicpatterns.com/uploads/wqSWnb5FtSLTGQKr2ccwUc/Mockup_kit_antiinflamatorio.png',
    bonuses: [
      '40 recetas para almuerzos y cenas antiinflamatorias',
      '40 recetas para desayunos y meriendas antiinflamatorias',
      '40 recetas saludables antiinflamatorias',
    ],
    keyBenefits: [
      'Ingredientes con propiedades antiinflamatorias',
      'Más energía y menos dolores articulares',
      'Apoya la salud digestiva y metabólica',
    ],
  },
  {
    id: 'hipotiroidismo',
    name: 'Kit Hipotiroidismo',
    color: '#1A5C5A',
    description:
      'Qué comer y qué evitar para acompañar tu tratamiento desde la alimentación.',
    hook: 'Acompañá tu tratamiento con alimentos que sí ayudan.',
    oldPrice: 29980,
    price: 11990,
    icon: 'Activity',
    image:
      'https://cdn.magicpatterns.com/uploads/6UvfQUT7koMkVaWtUpTsjC/Mockup_kit_hipotiroidismo.png',
    badge: 'RECOMENDADO',
    bonuses: [
      '40 recetas para almuerzos y cenas para hipotiroidismo',
      '40 recetas para desayunos y meriendas para hipotiroidismo',
      '40 recetas saludables para hipotiroidismo',
    ],
    keyBenefits: [
      'Acompaña tu tratamiento médico',
      'Identificá qué alimentos evitar y cuáles priorizar',
      'Ayuda a equilibrar metabolismo y energía',
    ],
  },
  {
    id: 'menopausia',
    name: 'Kit Post Menopausia',
    color: '#8B5A6A',
    description:
      'Diseñado para los cambios hormonales de esta etapa. Comé rico y sentite mejor.',
    hook: 'Comé pensando en tus hormonas, no en contra de ellas.',
    oldPrice: 29980,
    price: 11990,
    icon: 'Flower2',
    image:
      'https://cdn.magicpatterns.com/uploads/e7kenksYfazM1eif9eEQAb/Mockup_kit_menopausia.png',
    bonuses: [
      '40 desayunos para la post menopausia',
      '40 almuerzos para la post menopausia',
      '50 recetas para equilibrio hormonal y bienestar',
    ],
    keyBenefits: [
      'Diseñado para los cambios hormonales',
      'Apoya el control de peso y los sofocos',
      'Ingredientes amigables con tu salud ósea',
    ],
  },
]
